import { ROLE } from 'api/config';
import { IS_ENTERPRISE } from 'config';

const slug = {
  BASE: '/coso',
  LOGIN: '/login',
  DATA: '/data/:stationType',
  DATA_WITH_PARAMS: '/data/',
  QA: '/qa',
  CO_SO: {
    LIST: '/coso',
    CREATE: '/coso/create',
    EDIT: '/coso/:_id',
    EDIT_WITH_ID: '/coso/',
    VIEW: '/coso/view/:_id',
    VIEW_WITH_ID: '/coso/view/',
  },
  FACILITY_EIA: {
    LIST: '/facilityeia',
    CREATE: '/facilityeia/create',
    EDIT: '/facilityeia/:_id',
    EDIT_WITH_ID: '/facilityeia/',
    VIEW: '/facilityeia/view/:_id',
    VIEW_WITH_ID: '/facilityeia/view/',
  },
  INSPECTTION: {
    LIST: '/inspection',
    CREATE: '/inspection/create',
    EDIT: '/inspection/:_id',
    EDIT_WITH_ID: '/inspection/',
    VIEW: '/inspection/view/:_id',
    VIEW_WITH_ID: '/inspection/view/',
    VIEW_CHILD: '/inspection/view-detail-child/:_id/:parentId',
    VIEW_WITH_ID_CHILD: '/inspection/view-detail-child/',
    EDIT_CHILD: '/inspection/detail-child/:_id/:parentId',
    EDIT_WITH_ID_CHILD: '/inspection/detail-child/',
  },
  AUDIT: {
    LIST: '/audit',
    CREATE: '/audit/create',
    EDIT: '/audit/:_id',
    EDIT_WITH_ID: '/audit/',
    VIEW: '/audit/view/:_id',
    VIEW_WITH_ID: '/audit/view/',
    VIEW_CHILD: '/audit/view-detail-child/:_id/:parentId',
    VIEW_WITH_ID_CHILD: '/audit/view-detail-child/',
    EDIT_CHILD: '/audit/detail-child/:_id/:parentId',
    EDIT_WITH_ID_CHILD: '/audit/detail-child/',
  },
  ENVIRONMENT_PROTECTION_WORK: {
    LIST: '/environment-protection-work',
    CREATE: '/environment-protection-work/create',
    EDIT: '/environment-protection-work/:_id',
    EDIT_WITH_ID: '/environment-protection-work/',
    VIEW: '/environment-protection-work/view/:_id',
    VIEW_WITH_ID: '/environment-protection-work/view/',
  },
  LEGAL_DOCUMENTS: {
    LIST: '/legal-document',
    CREATE: '/legal-document/create',
    EDIT: '/legal-document/:_id',
    EDIT_WITH_ID: '/legal-document/',
    VIEW: '/legal-document/view/:_id',
    VIEW_WITH_ID: '/legal-document/view/',
  },
  BIODIVERSITY: {
    LIST: '/biodiversity',
    CREATE: '/biodiversity/create',
    EDIT: '/biodiversity/:_id',
    EDIT_WITH_ID: '/biodiversity/',
    DETAIL: '/biodiversity/detail/:_id',
    DETAIL_WITH_ID: '/biodiversity/detail/',
    SPECIES: '/biodiversity/detail/:_id/species',
  },
  SPECIES: {
    LIST: '/species',
    CREATE: '/species/create',
    EDIT: '/species/:_id',
    EDIT_WITH_ID: '/species/',
    VIEW: '/species/view/:_id',
    VIEW_WITH_ID: '/species/view/',
  },
  FACILITY_PERMIT: {
    LIST: '/facilitypermit',
    CREATE: '/facilitypermit/create',
    EDIT: '/facilitypermit/:_id',
    EDIT_WITH_ID: '/facilitypermit/',
    VIEW: '/facilitypermit/view/:_id',
    VIEW_WITH_ID: '/facilitypermit/view/',
  },
  FACILITY_EMISSTION: {
    LIST: '/facilityemission',
    CREATE: '/facilityemission/create',
    EDIT: '/facilityemission/:_id',
    EDIT_WITH_ID: '/facilityemission/',
    VIEW: '/facilityemission/view/:_id',
    VIEW_WITH_ID: '/facilityemission/view/',
  },
  FACILITY_DEVICE: {
    LIST: '/facilitydevice',
    CREATE: '/facilitydevice/create',
    EDIT: '/facilitydevice/:_id',
    EDIT_WITH_ID: '/facilitydevice/',
    VIEW: '/facilitydevice/view/:_id',
    VIEW_WITH_ID: '/facilitydevice/view/',
  },
  MAP: {
    BASE: '/map',
  },
  MONITORING_DATA: {
    BASE: '/monitoring',
    MAP: '/monitoring/map',
  },
  ENVI_PROTECT_FEE: {
    LIST: '/enviProtectFee',
    CREATE: '/enviProtectFee/create',
    EDIT: '/enviProtectFee/:_id',
    EDIT_WITH_ID: '/enviProtectFee/',
    VIEW: '/enviProtectFee/view/:_id',
    VIEW_WITH_ID: '/enviProtectFee/view/',
  },
  ENVI_MONITORING_REPORT: {
    LIST: '/enviMonitoringReport',
    CREATE: '/enviMonitoringReport/create',
    EDIT: '/enviMonitoringReport/:_id',
    EDIT_WITH_ID: '/enviMonitoringReport/',
    VIEW: '/enviMonitoringReport/view/:_id',
    VIEW_WITH_ID: '/enviMonitoringReport/view/',
  },
  HAZARDOUS_WASTE_REPORT: {
    LIST: '/hazardousWasteReport',
    CREATE: '/hazardousWasteReport/create',
    EDIT: '/hazardousWasteReport/:_id',
    EDIT_WITH_ID: '/hazardousWasteReport/',
    VIEW: '/hazardousWasteReport/view/:_id',
    VIEW_WITH_ID: '/hazardousWasteReport/view/',
  },
  REPORT_TEMPLATES: {
    BASE: '/report-template',
    VIEW: '/report-template/:_id',
  },
  MANAGEMENT: {
    LIST: '/management',
    PRTR_INFO_PUB: {
      CREATE: '/management/prtr.info.pub/create',
      EDIT: '/management/prtr.info.pub/:_id',
      EDIT_WITH_ID: '/management/prtr.info.pub/',
    },
    PRTR_CONFIG_HOACHAT: '/management/prtr-config-sulphite',
  },
  ADMIN: {
    BASE: '/admin',
    LIST: '/admin',
  },
  REPORT: {
    BASE: '/report',
  },
  USER: {
    LIST: '/user',
    CREATE: '/user/create',
    EDIT: '/user/:_id',
    EDIT_WITH_ID: '/user/',
    VIEW: '/user/view/:_id',
    VIEW_WITH_ID: '/user/view/',
  },
};

export default slug;

export const menus = () => [
  {
    href: slug.CO_SO.LIST,
    title: 'Tên cơ sở',
    permissionRole: 'facility.view',
    showInMore: false,
  },
  {
    href: slug.INSPECTTION.LIST,
    title: 'Thanh tra',
    permissionRole: 'facilityInspection.view',
    showInMore: IS_ENTERPRISE,
  },
  {
    href: slug.AUDIT.LIST,
    title: 'Kiểm tra',
    permissionRole: 'facilityAudit.view',
    showInMore: IS_ENTERPRISE,
  },
  {
    href: slug.FACILITY_PERMIT.LIST,
    title: 'Giấy phép',
    permissionRole: 'facilityPermit.view',
    showInMore: false,
  },
  {
    href: slug.BIODIVERSITY.LIST,
    title: 'Đa dạng sinh học',
    permissionRole: 'biodiversity.view',
    showInMore: IS_ENTERPRISE,
  },
  {
    href: slug.FACILITY_EMISSTION.LIST,
    title: 'Quản lý ô nhiễm',
    permissionRole: ROLE().isModuleEmission ? 'facilityEmission.view' : false,
    showInMore: IS_ENTERPRISE,
  },
  {
    href: slug.MAP.BASE, //slug.CO_SO.LIST,
    title: 'Bản đồ',
    permissionRole: ROLE().isModuleMap ? 'map.view' : false,
    showInMore: false,
  },
  {
    href: slug.MONITORING_DATA.BASE, //slug.CO_SO.LIST,
    title: 'Số liệu quan trắc tự động',
    permissionRole: ROLE().isModuleMonitoring ? 'monitoringData.view' : false,
    showInMore: IS_ENTERPRISE,
  },
  {
    href: slug.ENVI_PROTECT_FEE.LIST,
    title: 'Phí bảo vệ môi trường',
    permissionRole: ROLE().isModuleProtectFee
      ? 'facilityEnviProtectFee.view'
      : false,
    showInMore: IS_ENTERPRISE,
  },
  {
    href: slug.FACILITY_EIA.LIST,
    title: 'Hồ sơ môi trường',
    // permissionRole: 'facilityeia.view',
    permissionRole: ROLE().isModuleFacilityeia ? 'facilityeia.view' : false,
    showInMore: false,
  },
  {
    href: slug.ENVIRONMENT_PROTECTION_WORK.LIST,
    title: 'BC Công tác BVMT',
    permissionRole: ROLE().isModuleEnvironmentProtectionWork
      ? 'environmentProtectionWork.view'
      : false,
    showInMore: false,
  },
  {
    href: slug.LEGAL_DOCUMENTS.LIST,
    title: 'Văn bản pháp lý',
    permissionRole: ROLE().isModuleLegalDocument ? 'legalDocument.view' : false,
    showInMore: IS_ENTERPRISE,
  },
  {
    href: slug.ENVI_MONITORING_REPORT.LIST,
    title: 'BC Quan trắc môi trường',
    permissionRole: ROLE().isModuleMonitoringReport
      ? 'facilityEnviMonitoringReport.view'
      : false,
    showInMore: IS_ENTERPRISE,
  },
  {
    href: slug.HAZARDOUS_WASTE_REPORT.LIST,
    title: 'BC Chất thải nguy hại',
    permissionRole: ROLE().isModuleWasteReport
      ? 'facilityHazarWasteReport.view'
      : false,
    showInMore: IS_ENTERPRISE,
  },
  {
    href: slug.FACILITY_DEVICE.LIST,
    title: 'Quản lý thiết bị',
    permissionRole: ROLE().isModuleFacilityDevice
      ? 'facilityDevice.view'
      : false,
  },
  {
    href: slug.REPORT.BASE,
    title: 'Báo cáo',
    permissionRole: ROLE().isModuleReport ? 'report.view' : false,
    showInMore: IS_ENTERPRISE,
  },
  {
    href: slug.MANAGEMENT.LIST,
    title: 'Quản lý',
    permissionRole: 'manage.full',
    showInMore: false,
  },
  {
    href: slug.ADMIN.LIST,
    title: 'Quản trị',
    permissionRole: 'admin.full',
    showInMore: false,
  },
];



// WEBPACK FOOTER //
// ./src/constants/slug.js